import { FC } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.teaser.BannerTop');

    return (
        <EditorLink
            href={`#dp3-teaser-B`}
            className={`${css.thecomp}`}
            dataLayer={{
                event: 'uaEvent',
                event_name: 'announcement_click',
                button_name: 'Sign up now!',
            }}
        >
            {t.rich('title', {
                t: (text: string) => <span className="t">{text}</span>,
            })}
        </EditorLink>
    );
};

export default TheComp;
